import React, { Component } from "react";
import "./print.scss";

class CallToActionPhone extends Component {
  formatPhoneWithDots = (mobilePhoneNo) => {
    const phoneStr = String(mobilePhoneNo || "").replace(/\D/g, "");

    if (phoneStr.length < 10) {
      return phoneStr ? (
        <div className="cta-phone-num-row">{phoneStr}</div>
      ) : null;
    }

    return (
      <div className="cta-phone-num-row">
        {phoneStr.slice(0, 3)}
        <div className="cta-phone-circle-divider" />
        {phoneStr.slice(3, 6)}
        <div className="cta-phone-circle-divider" />
        {phoneStr.slice(6)}
      </div>
    );
  };

  render() {
    const { agentData } = this.props;
    const { mobilePhoneNo } = agentData || {};
    const phoneDisplay = this.formatPhoneWithDots(mobilePhoneNo);

    return (
      <div className="print-call-to-action-phone">
        <p className="cta-phone-question">
          Curious what your home could be worth today?
        </p>
        <div className="cta-phone-row">
          <span className="cta-phone-connect">
            Let’s connect for a personalized valuation.
          </span>
          {phoneDisplay ? (
            <div className="cta-phone-number">{phoneDisplay}</div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default CallToActionPhone;
